import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import BarChart from '../../../Components/Charts/BarChart';
import { AppColors } from '../../../Utils/helper/AppColors';

const BarGraphCard = ({ data , colors , title , borderRadius = 0 }) => {

	const barChartData = {
		labels: Object.keys(data),
		datasets: [
			{
				label: 'Calls',
				data: Object.values(data),
				backgroundColor: colors.color, // Default color
				hoverBackgroundColor: colors.backgroundColor, // Color on hover
				borderRadius : {
					topLeft: borderRadius,
					topRight: borderRadius,
					bottomLeft: 0,
					bottomRight: 0,
				},
			},
		],
	};

	return (
		<Card sx={{ minHeight: '100%' }}>
			<Stack mb={2} direction="row" justifyContent="space-between" px={1} width={'100%'}>
				<Typography textAlign={'center'} fontFamily={'Poppins'} fontSize={14} fontWeight={600} lineHeight={'150%'}>
					{title}
				</Typography>
			</Stack>
			
			<BarChart data={barChartData} borderRadius={borderRadius} width="100%" height={300} />
		</Card>
	);
};

export default BarGraphCard;
